// extracted by mini-css-extract-plugin
export default {"menu-item-optimization-result":"OptimizationContextMenu_menu-item-optimization-result__HToI9"};